import script from "./UpgradePrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradePrompt.vue?vue&type=script&setup=true&lang=js"

import "./UpgradePrompt.vue?vue&type=style&index=0&id=246d9bb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246d9bb0"]])

export default __exports__